//fade style possible?
//automatically speed depending on

export const addToBackpack = (bpIsOpen = false) => {
  let backpackBaseAimationSpeedMS = 1000; //will be reduced depending on distance between start / end point
  const availableWidth = window.innerWidth - 50;
  const availableHeight = window.innerHeight - 50;
  let lastCursorPosition = [availableWidth / 2, availableHeight / 2];
  const backpackEl = document.querySelector('.far.fa-backpack');
  if (backpackEl) {
    let backpackIconPosition = [
      backpackEl.getBoundingClientRect().left,
      backpackEl.getBoundingClientRect().top,
    ];
    let backpackPosition = [200, availableHeight];

    const image = document.createElement('img');
    image.src = '/experience/backpack/color1.png';
    const backpackAimationSpeedMS =
      backpackBaseAimationSpeedMS *
      ((lastCursorPosition[0] + lastCursorPosition[1]) / (availableWidth + availableHeight));
    // image.style = `position: 'absolute',left: ${lastCursorPosition[0]}, top: ${lastCursorPosition[1]}, transition: 'ease 2s'`;
    image.style.position = 'absolute';
    image.style.transition = `${backpackAimationSpeedMS}ms ease`;
    image.style.left = `${lastCursorPosition[0]}px`;
    image.style.top = `${lastCursorPosition[1]}px`;
    image.width = 50;
    image.height = 50;
    image.style.zIndex = '9999';
    image.style.opacity = '0.4';
    document.body.append(image);
    //timeout after appending image to body
    setTimeout(() => {
      if (bpIsOpen) {
        //moves to backpack
        image.style.left = `${backpackPosition[0]}px`;
        image.style.top = `${backpackPosition[1]}px`;
      } else {
        //moves to backpack icon right
        image.style.left = `${backpackIconPosition[0]}px`;
        image.style.top = `${backpackIconPosition[1]}px`;
      }
      image.width = 25;
      image.height = 25;
      image.style.opacity = '1';
      //remove icon after animation
      setTimeout(() => {
        document.body.removeChild(image);
      }, backpackAimationSpeedMS);
    }, 100);
  }
};
